import { Dropdown } from 'approot/shared/dropdown/dropdown';
import IconPlusInCircle from 'approot/shared/icons/icon-plus-in-circle';
import { DropdownItem } from 'approot/shared/dropdown/dropdown-item.style';
import { EditorControlAddBetween } from './editor-activity-controls.style';

export const EDITOR_ACTIVITY_MENU_CONTAINER = 'editor-activity-menu-container';

export const EditorActivityControlButton = ({
  disabled,
  onClick,
}: {
  disabled?: boolean;
  onClick?: () => void;
}) => (
  <EditorControlAddBetween
    type="button"
    aria-label="Add Activity options"
    disabled={disabled}
    onClick={onClick}
    data-selector="add-activity-options"
  >
    <IconPlusInCircle width={16} height={16} />
  </EditorControlAddBetween>
);

export const EditorActivityControls = ({
  canAddActivity,
  canAddSubActivity,
  onAddActivity,
  onAddSubActivity,
}: {
  canAddActivity: boolean;
  canAddSubActivity: boolean;
  onAddActivity: () => void;
  onAddSubActivity: () => void;
}) => {
  return (
    <Dropdown
      data-selector="add-activity-options"
      aria-label="Add Activity options"
      placement="right-start"
      menuContainerElement={EDITOR_ACTIVITY_MENU_CONTAINER}
      dropdownButtonContents={
        <EditorControlAddBetween type="button">
          <IconPlusInCircle width={16} height={16} />
        </EditorControlAddBetween>
      }
      dropdownContents={
        <>
          {canAddActivity && (
            <DropdownItem
              key="add-activity"
              onClick={onAddActivity}
              data-selector="option-add-activity"
            >
              Add Activity
            </DropdownItem>
          )}
          {canAddSubActivity && (
            <DropdownItem
              key="add-sub-activity"
              onClick={onAddSubActivity}
              data-selector="option-add-sub-activity"
            >
              Add Sub-activity
            </DropdownItem>
          )}
        </>
      }
    />
  );
};
